import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propList: [],
  updating: false,
  backupData: null,
}

const curatorBackupSlicer = createSlice({
  name: "curatorBackup",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setUpdating: (state, { payload }) => {
      state.updating = payload;
    },
    setBackupData: (state, { payload }) => {
      state.backupData = payload;
    }
  },
});

export const {
  setUpdating,
  setBackupData,
} = curatorBackupSlicer.actions;
export const curatorBackupActions = curatorBackupSlicer.actions;

export const curatorBackupSelector = (state) => state.curatorBackup;
export const curatorBackupReducer = curatorBackupSlicer.reducer;
export default curatorBackupReducer;


export const selectBackupData = (state) => state.curatorBackup.backupData;